import { gapiCall } from './gapi';

// Add a domainInvitation to a suscription action types 
export const INVITE_DOMAIN = "INVITE_DOMAIN";
export const INVITE_DOMAIN_SUCCESS = "INVITE_DOMAIN_SUCCESS";
export const INVITE_DOMAIN_ERROR = "INVITE_DOMAIN_ERROR";

// Remove a domainInvitation from a suscription action types 
export const REMOVE_DOMAIN = "REMOVE_DOMAIN";
export const REMOVE_DOMAIN_SUCCESS = "REMOVE_DOMAIN_SUCCESS";
export const REMOVE_DOMAIN_ERROR = "REMOVE_DOMAIN_ERROR";

// Fetch domainInvitations related to a user
export const FETCH_USER_DOMAIN_INVITATIONS = "FETCH_USER_DOMAIN_INVITATIONS";
export const FETCH_USER_DOMAIN_INVITATIONS_SUCCESS = "FETCH_USER_DOMAIN_INVITATIONS_SUCCESS";
export const FETCH_USER_DOMAIN_INVITATIONS_ERROR = "FETCH_USER_DOMAIN_INVITATIONS_ERROR"

// Accept domainInvitations related to a user
export const ACCEPT_USER_DOMAIN_INVITATIONS = "ACCEPT_USER_DOMAIN_INVITATIONS";
export const ACCEPT_USER_DOMAIN_INVITATIONS_SUCCESS = "ACCEPT_USER_DOMAIN_INVITATIONS_SUCCESS";
export const ACCEPT_USER_DOMAIN_INVITATIONS_ERROR = "ACCEPT_USER_DOMAIN_INVITATIONS_ERROR"

/**
 * Add a domainInvitation to a suscription action creator
 * @param {String} userId 
 */
export const inviteDomain = (subscriptionId) => {
  return {
    type: INVITE_DOMAIN,
    subscriptionId
  }
}

/**
 * Add a domainInvitation to a suscription success action creator
 * @param {String} subscriptionId 
 * @param {Object} domain the domain invited
 */
export const inviteDomainSuccess = (subscriptionId, domain) => {
  return {
    type: INVITE_DOMAIN_SUCCESS,
    domain,
    subscriptionId
  }
}

/**
 * Add a domainInvitation to a suscription error action creator
 * @param {String} subscriptionId 
 * @param {Error} error 
 */
export const inviteDomainError = (subscriptionId, error, domainName) => {
  return {
    type: INVITE_DOMAIN_ERROR,
    error,
    subscriptionId,
    domainName
  }
}

/**
 * Remove a domainInvitation from a suscription action creator
 * @param {String} domainInvitationId 
 */
export const removeDomain = (domainInvitationId) => {
  return {
    type: REMOVE_DOMAIN,
    domainInvitationId
  }
}

/**
 * Remove a domainInvitation from a suscription success action creator 
 * @param {String} domainInvitationId 
 */
export const removeDomainSuccess = (domainInvitationId, subscriptionId, domainName) => {
  return {
    type: REMOVE_DOMAIN_SUCCESS,
    subscriptionId,
    domainInvitationId,
    domainName
  }
}

/**
 * Remove a domainInvitation from a suscription error action creator
 * @param {String} domainInvitationId 
 * @param {Error} error 
 */
export const removeDomainError = (domainInvitationId, error, domainName) => {
  return {
    type: REMOVE_DOMAIN_ERROR,
    error,
    domainInvitationId,
    domainName
  }
}

/**
 * Fetch domainInvitations related to a user action creator
 * @param {String} userId 
 */
export const fetchUserDomainInvitations = (userId) => {
  return {
    type: FETCH_USER_DOMAIN_INVITATIONS,
    userId,
  }
}

/**
 * Fetch domainInvitations related to a usera success action creator 
 * @param {String} userId 
 */
export const fetchUserDomainInvitationsSuccess = (userId, payload) => {
  return {
    type: FETCH_USER_DOMAIN_INVITATIONS_SUCCESS,
    userId,
    payload
  }
}

/**
 * Fetch domainInvitations related to a user error action creator
 * @param {String} userId  
 * @param {Error} error 
 */
export const fetchUserDomainInvitationsError = (userId, error) => {
  return {
    type: FETCH_USER_DOMAIN_INVITATIONS_ERROR,
    userId,
    error
  }
}

/**
 * Accept domainInvitations related to a user action creator
 * @param {String} domainInvitationId
 * @param {String} userId 
 */
export const acceptUserDomainInvitation = (domainInvitationId, userId) => {
  return {
    type: ACCEPT_USER_DOMAIN_INVITATIONS,
    domainInvitationId,
    userId,
  }
}

/**
 * Accept domainInvitations related to a usera success action creator 
 * @param {String} domainInvitationId
 * @param {String} userId 
 */
export const acceptUserDomainInvitationSuccess = (domainInvitationId, userId) => {
  return {
    type: ACCEPT_USER_DOMAIN_INVITATIONS_SUCCESS,
    domainInvitationId,
    userId,
  }
}

/**
 * Fetch domainInvitations related to a user error action creator
 * @param {String} domainInvitationId
 * @param {String} userId  
 * @param {Error} error 
 */
export const acceptUserDomainInvitationError = (domainInvitationId, userId, error) => {
  return {
    type: ACCEPT_USER_DOMAIN_INVITATIONS_ERROR,
    domainInvitationId,
    userId,
    error
  }
}

/**
 * Add a domainInvitation for a subscription, 
 * @param {String} subscriptionId 
 * @param {Object} domain an object with the domainValue 
 */
export const inviteDomainBySubscriptionId = (subscriptionId, domain )=> dispatch =>
  dispatch(inviteDomain(subscriptionId, domain))
  && dispatch(gapiCall(client => client.billing.subscriptions.domainInvitations.add({ subscriptionId, domain })))
    .then(res => dispatch(inviteDomainSuccess(subscriptionId, res)))
    .catch(error => dispatch(inviteDomainError(subscriptionId, error, domain)))

/**
 * Remove a specific domain from a subscription, 
 * @param {String} domainInvitationId 
 */
export const removeDomainByDomainInvitationId = (domainInvitationId, subscriptionId, domainName) => dispatch =>
  dispatch(removeDomain(domainInvitationId))
  && dispatch(gapiCall(client => client.billing.subscriptions.domainInvitations.remove({ domainInvitationId })))
    .then(res => dispatch(removeDomainSuccess(domainInvitationId, subscriptionId, domainName)))
    .catch(error => dispatch(removeDomainError(domainInvitationId, error, domainName)))

/**
 * Retreive "pending" domain invitations for a user
 * @param {String} userId 
 */   
export const doFetchUserDomainInvitations = (userId) => dispatch => 
  dispatch(fetchUserDomainInvitations(userId))
  && dispatch(gapiCall(client => client.billing.users.domainInvitations.get({userId})))
    .then(res => {
      return dispatch(fetchUserDomainInvitationsSuccess(userId, res))
    })
    .catch(error => dispatch(fetchUserDomainInvitationsError(userId, error)))

/**
 * Accept a "pending" domain invitations for a user
 * @param {String} userId 
 */   
export const doAcceptUserDomainInvitation = (domainInvitationId,userId) => dispatch => 
  dispatch(acceptUserDomainInvitation(domainInvitationId, userId))
  && dispatch(gapiCall(client => client.billing.users.domainInvitations.accept({domainInvitationId, userId})))
    .then(res => dispatch(acceptUserDomainInvitationSuccess(domainInvitationId, userId)))
    .catch(error => dispatch(acceptUserDomainInvitationError(domainInvitationId, userId, error)))



// WEBPACK FOOTER //
// ./src/actions/domains.js